<ng-container [ngSwitch]="params.oem">
  <svc-gm-dashboard *ngSwitchCase="'GM'"></svc-gm-dashboard>
  <svc-ford-dashboard *ngSwitchCase="'FO'"></svc-ford-dashboard>
  <svc-toyota-dashboard *ngSwitchCase="'TOY'"></svc-toyota-dashboard>
  <svc-chrysler-dashboard *ngSwitchCase="'CH'"></svc-chrysler-dashboard>
  <svc-nissan-dashboard *ngSwitchCase="'NIS'"></svc-nissan-dashboard>
  <svc-hyundai-dashboard *ngSwitchCase="'HYU'"></svc-hyundai-dashboard>
</ng-container>